import React, { FC } from "react";
import NumberFormat from "react-number-format";
import { IInputProps } from "../../../modules/form";

export const InputNumber: FC<IInputProps> = ({ value, onChange, onTouched, isDisabled }) => {
  return (
    <NumberFormat
      allowLeadingZeros={true}
      value={value}
      onValueChange={(value) => {
        onChange(value.formattedValue);
      }}
      isNumericString
      onBlur={() => onTouched()}
      disabled={isDisabled}
    />
  );
};
